import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, LICENSE } from '../../Server'
import axios from 'axios';
import CreateSadmin from './CreateSadmin';
import { connect } from "react-redux";
import HeaderMobileSearch from '../../common/HeaderMobileSearch';
import HeaderMobile from '../../common/HeaderMobile';
import TableSkelton from '../../skeltonloader/TableSkelton';
import NoDataFound from '../../common/NoDataFound';

class ListSAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingSadmin: false,
            List: [],
            message: "",
            loading :false,
        }
    }
    componentDidMount() {
        this.getTotalCAdmin()
        this.dataByLicense()
    }
    dataByLicense = () => {
        if (LICENSE.application_Dashboard) {
            this.setState(this.state)
        } else {
            setTimeout(() => {
                this.dataByLicense()
            }, 1000)
        }
    }
    getTotalCAdmin = () => {
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        var data = {
            c_id: ud.main_id
        }
        let url = `${SERVER_IP}/siteList`;
        
        // For SAdmin in Site Admin Dashboard
        if (ud && ud.usertype === 2) {
            data = {
                s_id: ud.main_id,
                admin_type:"sadmin"
            }
            url = `${SERVER_IP}/multi/admin/list`;
        }

        axios.post(url, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    // For SAdmin in Site Admin Dashboard
                    if (ud && ud.usertype === 2) {
                        if (response.data.result) {
                            _this.setState({ List: response.data.result, message: "No Record Found." });
                        }
                    } else {
                        if (response.data.siteList) {
                            _this.setState({ List: response.data.siteList, message: "No Record Found." });
                        }
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalCAdmin();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }
    createSiteAdmin = () => {
        window.location.href = "/create/sadmin"
    }
    openUserList = (list) => {
        sessionStorage.setItem('c_admin_s_userlist', JSON.stringify(list))
        window.location.href = "/create/listuser_cadmin"
    }
    openUserType = (list) => {
        sessionStorage.setItem('c_admin_s_typelist', JSON.stringify(list))
        window.location.href = "/create/typehierarchycadmin"
    }
    openUserWorkflow = (list) => {
        sessionStorage.setItem('c_admin_s_workflowlist', JSON.stringify(list))
        window.location.href = "/create/listworkflow_cadmin"
    }
    EditSite = (list) => {
        sessionStorage.setItem('c_admin_s_profile', JSON.stringify(list))
        window.location.href = "/create/siteprofile"
    }

    render() {
        const { errors, loading } = this.state;
                  const { user } = this.props;
                  const { isMobile } = user;
        return (
          <div>
            {isMobile ? (
              <>
<HeaderMobile/>              
                {/* {" "}
                <HeaderMobileSearch
                  showFilterBtn={true}
                  backBtn={true}
                  searchAnimated={false}
                  searchMode={false}
                />{" "} */}
              </>
            ) : (
              <></>
            )}
            <div className="xp-breadcrumbbar xp-heading">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <h4 className="xp-page-title">List Of Site Admins</h4>
                </div>
                <div className="col-md-12 col-lg-12">
                  <div className="xp-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a onClick={() => (window.location.href = "/dashboard")}>
                          <i className="icon-home"></i>
                        </a>
                      </li>
                      <li className="breadcrumb-item active">Site Admins</li>
                    </ol>
                  </div>
                </div>
                <div className="col-md-12">
                  {LICENSE.organizationManagement ? (
                    LICENSE.organizationManagement.total_sites == "UNLIMITED" ? (
                      <button className="btn btn-primary btn-lg active" onClick={this.createSiteAdmin}>
                        Create Site Admin
                      </button>
                    ) : Number(LICENSE.organizationManagement.total_sites) -
                        LICENSE.organizationManagement.total_sites_usage <=
                      0 ? (
                      <button
                        className="btn btn-primary btn-lg active"
                        data-toggle="tooltip"
                        title="No Site Remaining"
                        disabled
                      >
                        Create Site Admin
                      </button>
                    ) : (
                      <button className="btn btn-primary btn-lg active" onClick={this.createSiteAdmin}>
                        Create Site Admin
                      </button>
                    )
                  ) : null}
                </div>
              </div>
            </div>
            <div className="xp-contentbar p-30">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card m-b-30">
                    <div className="card-header bg-white">
                      <h5 className="card-title text-black mb-0 textcenter">Site Admin List</h5>
                    </div>

                    <div className="card-body">
                      <div className="table-responsive">
                        {this.state.List.length === 0 ? (
                          this.state.message === "" ? (
                            // loader
                            <div className="lds-spinner">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          ) : (
                
                            // loader-end
                            <div className="message-no-record"> {this.state.message} </div>
                          )
                        ) : null}
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th style={{ width: "5%" }}>No</th>
                              <th>Site Name</th>
                              <th>Location Name</th>
                              <th>Details</th>
                              <th style={{ width: "15%" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                             {loading ? 
                                <TableSkelton rowCount={3} colCount={8} />
                            :
                            (this.state.List.length == 0) ? (
                                <tr>
                                  <td colSpan="8" className="text-center message-no-record">
                                    <NoDataFound headText={this.state.message} />
                                  </td>
                                </tr>
                            ) : (
                            this.state.List.map((list, index) => (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>{list.site_name}</td>
                                <td>{list.location_name}</td>
                                <td>{list.details}</td>
                                <td>
                                  <div className="tabledit-toolbar btn-toolbar" style={{ textAlign: "left" }}>
                                    <div className="btn-group btn-group-sm" style={{ float: "none" }}>
                                      <button
                                        type="button"
                                        className=" btn  btn-warning"
                                        style={{ float: "none", margin: "5px" }}
                                        onClick={() => this.EditSite(list)}
                                      >
                                        Edit
                                      </button>
                                      {ud && ud.usertype === 1 && (
                                        <>
                                          <button
                                            type="button"
                                            className=" btn  btn-info"
                                            style={{ float: "none", margin: "5px" }}
                                            onClick={() => this.openUserType(list)}
                                          >
                                            Organizational Structures
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            style={{ float: "none", margin: "5px" }}
                                            onClick={() => this.openUserList(list)}
                                          >
                                            Users{" "}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            style={{ float: "none", margin: "5px" }}
                                            onClick={() => this.openUserWorkflow(list)}
                                          >
                                            Workflow{" "}
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                        )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
// export default ListSAdmin

const mapStateToProps = (state) => ({
  user: state.userData,
});


export default connect(mapStateToProps)(ListSAdmin);